<script>
  import { Rate } from 'element-ui'
  export default {
    name:'ElRate',
    extends:Rate
  }
</script>
